import { render, staticRenderFns } from "./formSubject.vue?vue&type=template&id=5ff43bfa&scoped=true&"
import script from "./formSubject.vue?vue&type=script&lang=js&"
export * from "./formSubject.vue?vue&type=script&lang=js&"
import style0 from "./formSubject.vue?vue&type=style&index=0&id=5ff43bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff43bfa",
  null
  
)

export default component.exports